function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25 12C26.6569 12 28 13.3431 28 15V24C28 25.6569 26.6569 27 25 27H13C11.3431 27 10 25.6569 10 24V15C10 13.3431 11.3431 12 13 12H25ZM14.75 15.5C14.3358 15.5 14 15.8358 14 16.25C14 16.6642 14.3358 17 14.75 17H18.25C18.6642 17 19 16.6642 19 16.25C19 15.8358 18.6642 15.5 18.25 15.5H14.75ZM14.75 18.5C14.3358 18.5 14 18.8358 14 19.25C14 19.6642 14.3358 20 14.75 20H21.25C21.6642 20 22 19.6642 22 19.25C22 18.8358 21.6642 18.5 21.25 18.5H14.75ZM14 22.25C14 22.6642 14.3358 23 14.75 23H19.25C19.6642 23 20 22.6642 20 22.25C20 21.8358 19.6642 21.5 19.25 21.5H14.75C14.3358 21.5 14 21.8358 14 22.25ZM29.0005 15.5113C29.9023 16.0888 30.5 17.0996 30.5 18.25V24.25C30.5 27.1495 28.1495 29.5 25.25 29.5H16.25C15.0996 29.5 14.0888 28.9023 13.5113 28.0005L25.25 28C27.3211 28 29 26.3211 29 24.25L29.0005 15.5113Z",
  fill: "#217BC7"
});

function SvgMulticard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMulticard);
export default __webpack_public_path__ + "static/media/multicard.1887ca5f.svg";
export { ForwardRef as ReactComponent };